export default "__VITE_ASSET__CnZH9VZ5__"